"use strict";
angular.module('appMarketplace')
    .service('UserService', ['$http', '$state', 'UrlService', 'NavigationService', function ($http, $state, UrlService, NavigationService) {
        var service = this;

        service.getUserInfo = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/userInfo')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.getAccountCodePreference = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/accountCodePreference')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updateUser = function (user, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/userInfo'),
                data: user
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getEmailCategoryGroups = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/emailCategoryGroups')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updateCategoryGroups = function (categoryIds, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/emailCategoryGroups'),
                data: categoryIds
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getPasswordHint = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/passwordHint')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updatePasswordHint = function (questionId, questionAnswer, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/passwordHint'),
                data: {
                    userQuestion: questionId,
                    userAnswer: questionAnswer
                }
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getApprovalDelegationSettings = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/approvalDelegation')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.updateApprovalDelegationSettings = function (settings, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/approvalDelegation'),
                data: settings
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.isAccountCodeValid = function (codeAccount, columnNumber, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/accountCodeValidity/' + codeAccount),
                params: {column_number: columnNumber}
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data.accountCodeValid);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.acceptPrivacyPolicy = function (successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/acceptPrivacyPolicy')
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.showRequiredFormIfAnyNeeded = function (changeLocation) {
            NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                var state = 'root-state';
                if (!currentAccount.privacyPolicyAccepted) {
                    state = 'accept-privacy-policy-state';
                } else if (currentAccount.passwordUpdateNeeded) {
                    state = 'update-password-state';
                } else if (currentAccount.passwordHintUpdateNeeded) {
                    state = 'update-password-hint-state';
                }
                if ($state.current.name === state) {
                    return;
                }
                $state.go(state, null, {location: changeLocation});
            });
        }
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/user-service.js
// module id = 33
// module chunks = 21 25 28 30 32